import { createSelector } from '@reduxjs/toolkit';

import { withStrictError } from '../../../shared/lib';
import { RootState } from '../../../app';

import { CHAT_SETTINGS_DEFAULT } from '@distribute/shared/chat';

import { ChatStructuredSuggestionData } from '@distribute/shared/types';

import { ConversationState } from './types';

import { isRelevantSuggestion } from '../lib';

export const selectChatScreen = ({ chat }: RootState) => chat.screen;

export const selectChats = ({ chat }: RootState) => chat.chats;

export const selectIsChatLoading = ({ chat }: RootState) => chat.isChatLoading;
export const selectIsChatDeleting = ({ chat }: RootState) =>
  chat.isChatDeleting;

export const selectIsChatDeleteModalOpen = ({ chat }: RootState) =>
  chat.isChatDeleteModalOpen;

export const selectConversationState = ({ chat }: RootState) =>
  chat.conversationState;

export const selectConversationIsActive = ({ chat }: RootState) =>
  [ConversationState.Streaming, ConversationState.Suggestion].includes(
    chat.conversationState
  );

export const selectCurrentChat = ({ chat }: RootState) => chat.currentChat;

export const selectCurrentChatWithError = ({ chat }: RootState) =>
  withStrictError(chat.currentChat, 'currentChat');

export const selectConversation = ({ chat }: RootState) => chat.conversation;

export const selectConversationWithError = ({ chat }: RootState) =>
  withStrictError(chat.conversation, 'conversation');

export const selectLoadingMessageIds = ({ chat }: RootState) =>
  chat.loadingMessageIds;

export const selectConversationSuggestions = ({ chat }: RootState) =>
  (chat.conversation?.structuredResponse.filter(isRelevantSuggestion) ??
    []) as ChatStructuredSuggestionData[];

export const selectIsSuggestionMode = ({ chat }: RootState) =>
  chat.conversationState === ConversationState.Suggestion;

export const selectChatsEntityId = ({ chat }: RootState) =>
  withStrictError(chat.chatsEntityId, 'chatsEntityId');

export const selectChatSettings = ({ chat }: RootState) => chat.settings;

export const selectChatTemperature = createSelector(
  [selectChatSettings],
  (settings) => settings?.temperature ?? CHAT_SETTINGS_DEFAULT.temperature
);

export const selectChatWritingStyle = createSelector(
  [selectChatSettings],
  (settings) => settings?.writingStyle ?? CHAT_SETTINGS_DEFAULT.writingStyle
);

export const selectChatDocumentLanguage = createSelector(
  [selectChatSettings],
  (settings) =>
    settings?.documentLanguage ?? CHAT_SETTINGS_DEFAULT.documentLanguage
);
